import { Maybe } from 'types/FMSGraphqlTypes'
import { TDedicatedLanesPreferenceSchema } from '../components/DedicatedLanesModal/schema/DedicatedLanesPreferenceSchema'
import { TCarrierDedicatedLaneRatePreference } from '../types'

export const getDedicatedLanesDefaultValues = (
  dedicatedLaneRatePreference: Maybe<TCarrierDedicatedLaneRatePreference>
): TDedicatedLanesPreferenceSchema => {
  const { isInterestedInDedicatedLanes, minimumRatePerMile } = dedicatedLaneRatePreference || {}

  return {
    isInterestedInDedicatedLanes: isInterestedInDedicatedLanes || false,
    minimumRatePerMile: minimumRatePerMile || null,
  }
}
